<template>
    <section>
        <div class="row">
            <div class="col">
                <table class="table text-center">
                    <thead>
                        <tr>
                          <th width="25%">대상 활동</th>
                          <th width="50%">활동 내용</th>
                          <th width="25%">날짜</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="!!!alarms">
                            <th colspan="100%"> 활동 알림이 없습니다.</th>
                        </tr>
                        <tr v-else v-for="log in alarms" @click="updateAlarmReadAll(log)">
                            <td :title="log.id">"{{log.activityTitle}}"</td>
                            <td>
                                {{log.memberName}} 님,
                                <span v-if="log.msg">
                                    {{log.msg}}
                                </span>
                                <span v-else>
                                    {{!!alarmMap[log.type] ? alarmMap[log.type]['msg'] : ''}}
                                </span>
                            </td>
                            <td>
                              {{ $moment(log.createdDate).format('YYYY-MM-DD') }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>

</template>

<script>
    // import moment from 'moment';

    /* eslint-disable */
    export default {
        name: 'AlarmList',
        data() {
            return {
                alarms: [],
                alarmMap: {},
                search: {
                    page: 0,
                    size: 100,
                },
            }
        },
        components: {
        },
        props: {
            msgOnly: Boolean,
            memberId: Number,
        },
        methods: {
            getList() {
                let me = this;
                let u = new URLSearchParams(this.search).toString();

                let url = process.env.VUE_APP_MEMBER_API_URL + `/alarm/${this.memberId}?${u}`;
                //console.log(u);
                this.axios.get(url)
                    .then(function (res) {
                        if(me.$props.msgOnly) {
                            me.alarms = res.data.filter( d => d.msg);

                        } else {
                            me.alarms = res.data.filter( d => !d.msg);
                        }
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            getAlarmTypeMap() {
                let me = this;
                let url = process.env.VUE_APP_MEMBER_API_URL + `/alarmMap`;
                this.axios.get(url)
                    .then(function (res) {
                        me.alarmMap = res.data;
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            updateAlarmRead(log) {
                let me = this;
                if(log.isRead) {

                } else {

                    this.axios.put(process.env.VUE_APP_MEMBER_API_URL + `/alarm/${log.id}`)

                        .then(function (res) {
                        }).catch(function (error) {
                        console.log(error);
                    });

                }
                this.$router.push({ name: me.alarmMap[log.type]['url'], params: { id: log.activityId }})
            },
            updateAlarmReadAll(log) {
                let me = this;
                if(log.isRead) {

                } else {

                    this.axios.put(process.env.VUE_APP_MEMBER_API_URL + `/alarm/readall/${this.memberId}`)

                        .then(function (res) {
                        }).catch(function (error) {
                        console.log(error);
                    });

                }
                this.$router.push({ name: me.alarmMap[log.type]['url'], params: { id: log.activityId }})
            },

        },
        mounted() {
            this.getList();
            this.getAlarmTypeMap();
        },
        created() {
        },

        watch: {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
